import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class VisitTypesService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(visitType: any) {
    return this.http.post(this.configurations.apiAddress + "/api/VisitTypes/save", visitType);
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('name', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/VisitTypes/getAll', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/VisitTypes/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/VisitTypes/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/VisitTypes/getAll/');
  }
}
